import useSettingsStore from '@/store/modules/settings'
import useUserStore from '@/store/modules/user'
import axios from 'axios'
// import qs from 'qs'
import { toast } from 'vue-sonner'

const api = axios.create({
  baseURL: (import.meta.env.DEV && import.meta.env.VITE_OPEN_PROXY) ? '/proxy/' : import.meta.env.VITE_APP_API_BASEURL,
  timeout: 1000 * 60,
  responseType: 'json',
})

api.interceptors.request.use(
  (request) => {
    // 全局拦截请求发送前提交的参数
    const settingsStore = useSettingsStore()
    const userStore = useUserStore()
    // 设置请求头
    if (request.headers) {
      request.headers.locale = settingsStore.lang
      if (userStore.isLogin) {
        request.headers.authorization = `Bearer ${userStore.token}`
      }
    }
    // 是否将 POST 请求参数进行字符串化处理
    if (request.method === 'post') {
      // request.data = qs.stringify(request.data, {
      //   arrayFormat: 'brackets',
      // })
    }
    return request
  },
)

api.interceptors.response.use(
  (response) => {
    /**
     * 全局拦截请求发送后返回的数据，如果数据有报错则在这做全局的错误提示
     * 假设返回数据格式为：{ status: 0, msg: '', data: {} }
     * 规则是当 status 为 0 时表示操作成功，为 1 时表示操作失败
     * 操作失败时 msg 会返回错误信息
     */
    if (response.data.status === 1) {
      if (response.data.msg !== '') {
        toast.error(response.data.msg)
        return Promise.reject(response.data)
      }
    }
    else if (response.data.status === 401) {
      toast.error(response.data.msg)
      useUserStore().requestLogout()
    }
    // else {
    //   useUserStore().requestLogout()
    // }
    return Promise.resolve(response.data)
  },
  (error) => {
    // if (error.status === 401) {
    //   useUserStore().requestLogout()
    //   throw error
    // }
    let message = error.message
    if (message === 'Network Error') {
      message = '网络故障'
    }
    else if (message.includes('timeout')) {
      message = '接口请求超时'
    }
    else if (message.includes('Request failed with status code')) {
      message = `接口${message.substr(message.length - 3)}异常`
    }
    toast.error('Error', {
      description: message,
    })
    return Promise.reject(error)
  },
)

export default api
